/* eslint-disable lines-between-class-members */
import { observable, action, computed } from 'mobx';
import Cookies from 'js-cookie';
import { store } from '@/common/core/store/decorator';
import Contract from '@/newcar/core/model/contract';
import NEWCAR_CONST from '@/newcar/util/const';

// 新車用 申請フォームストア
@store({ persist: true, name: NEWCAR_CONST.FORM.ENTRY_FORM_LOCAL_STORAGE_KEY })
export default class ContractStore {
  @observable form = new Contract();

  @action
  setContract<T extends keyof Contract, U extends Contract[T]>(
    item: {key: T, value: U},
  ): void {
    let updateValue;
    switch (item.key) {
      case 'gender':
      case 'isSameAddress':
      case 'maritalStatus':
      case 'businessType':
      case 'businessAddressType':
      case 'residenceStatus':
        updateValue = Number(item.value);
        break;
      case 'year':
      case 'month':
      case 'day':
        if (item.value?.toString() === '') {
          updateValue = item.value;
        } else {
          updateValue = Number(item.value);
        }
        break;
      default:
        updateValue = item.value;
        break;
    }
    this.form = { ...this.form, [item.key]: updateValue };
  }

  @computed
  get getContract(): Contract {
    // 申込フォーム項目の追加があった場合に備え、初期値と現在のformを合わせて返却する
    this.form = { ...new Contract(), ...this.form };
    return this.form;
  }

  /**
   * CVの流入元を取得
   */
  @action
  async retrieveCVSource(): Promise<string | undefined> {
    const ans = Cookies.get('satr_source');
    this.setContract({ key: 'cvSource', value: ans });
    return ans;
  }

  /**
   * UTMパラメータを取得
   */
  @action
  async retrieveUtmParams(): Promise<{
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    previousUrl: string;
    lineId: string;
  }> {
    let utmSourceList = '';
    let utmMediumList = '';
    let utmCampaignList = '';
    let previousUrlList = '';
    let lineIdList = '';

    try {
      if (localStorage) {
        utmSourceList = localStorage.getItem('utmSourceList') || '[]';
        utmMediumList = localStorage.getItem('utmMediumList') || '[]';
        utmCampaignList = localStorage.getItem('utmCampaignList') || '[]';
        previousUrlList = localStorage.getItem('previousUrlList') || '[]';
        lineIdList = localStorage.getItem('lineId') || '';
      } else {
        utmSourceList = Cookies.get('utmSourceList') || '[]';
        utmMediumList = Cookies.get('utmMediumList') || '[]';
        utmCampaignList = Cookies.get('utmCampaignList') || '[]';
        previousUrlList = Cookies.get('previousUrlList') || '[]';
        lineIdList = Cookies.get('lineId') || '';
      }

      const utmSource = (JSON.parse(utmSourceList) as string[]).join(', ');
      const utmMedium = (JSON.parse(utmMediumList) as string[]).join(', ');
      const utmCampaign = (JSON.parse(utmCampaignList) as string[]).join(', ');
      const previousUrl = (JSON.parse(previousUrlList) as string[]).join(', ');
      const lineId = JSON.parse(lineIdList) as string;

      this.setContract({ key: 'utmSource', value: utmSource });
      this.setContract({ key: 'utmMedium', value: utmMedium });
      this.setContract({ key: 'utmCampaign', value: utmCampaign });
      this.setContract({ key: 'previousUrl', value: previousUrl });
      this.setContract({ key: 'lineId', value: lineId });

      return {
        utmSource,
        utmMedium,
        utmCampaign,
        previousUrl,
        lineId,
      };
    } catch (e) {
      this.setContract({ key: 'utmSource', value: '' });
      this.setContract({ key: 'utmMedium', value: '' });
      this.setContract({ key: 'utmCampaign', value: '' });
      this.setContract({ key: 'previousUrl', value: '' });
      this.setContract({ key: 'lineId', value: '' });

      return {
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        previousUrl: '',
        lineId: '',
      };
    }
  }
}
export const contractStore = new ContractStore();
